const EXPERIENCE_START_YEAR = 2017;
const EXPERIENCE_START_MONTH = 0;
const MONTHS_PER_YEAR = 12;
const MONTHS_BEFORE_PLUS = 6;

export const getExperienceYears = (asOf: Date = new Date()): string => {
  const monthsSinceStart = Math.max(
    0,
    (asOf.getFullYear() - EXPERIENCE_START_YEAR) * MONTHS_PER_YEAR +
      asOf.getMonth() -
      EXPERIENCE_START_MONTH
  );

  const fullYears = Math.floor(monthsSinceStart / MONTHS_PER_YEAR);
  const monthsAfterLastAnniversary = monthsSinceStart % MONTHS_PER_YEAR;
  const showPlus =
    fullYears > 0 && monthsAfterLastAnniversary >= MONTHS_BEFORE_PLUS;

  return `${fullYears}${showPlus ? "+" : ""}`;
};
